import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { AppState } from "../../store/configureStore";

interface PrivateRouteProps extends RouteProps {
    component: any;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, ...rest }) => {
    const token = useSelector((state: AppState) => state.user.token);
    const role = useSelector((state: AppState) => state.user.role);
    const loggedIn = useSelector((state: AppState) => state.login.loggedIn);

    return (
        <Route
            {...rest}
            render={props =>
                token && loggedIn && role !== "CountrySelect" ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: role === "CountrySelect" ? "/country-select" : "/public",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};
